import React, { Component } from 'react';
import { withRouter } from '../../utils/router-compat';
import CipDealerDetail from '../../components/CipDealerDetail/CipDealerDetail';
import {
  Row, Col,
} from 'reactstrap';

class CipRegitration extends Component {
  backToCipSummary = () => {
    //this.props.history.push('/cip-summary');
    this.goToCipSummary()
  }

  goToCipSummary = () => {
    if (this.props.history && this.props.history.push) {
      this.props.history.push({
        pathname: "/cip-summary",
        state: { isDisplayAddParticipantPopover: true }
      });
    } else if (this.props.router && this.props.router.navigate) {
       this.props.router.navigate("/cip-summary", { state: { isDisplayAddParticipantPopover: true } });
    } else {
       console.error("Navigation props (history/router) missing in CipRegitration", this.props);
    }
  }
  render() {
    return (
      <div>
        {/* <div className="page-header">CIP Registration</div> */}
        <div className="d-flex-row mt-2">
          <span onClick={() => this.backToCipSummary()} className="Merchandise-catalogu-link cursor-pointer" style={{ fontSize: '16px' }}>CIP Summary</span>&nbsp;&nbsp;
          <img src="images/right.svg" alt="" />&nbsp;&nbsp;
          <span className="cart-lbl" style={{ fontSize: '24px', width: 'auto' }}>CIP Registration</span>
        </div>
        <Row>
          <Col xl="9" md="12" xs="12">
            <CipDealerDetail
              goToCipSummary={this.goToCipSummary} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(CipRegitration);